<template>
  <div>
    <Loader v-if="all_store_menu_items_being_loaded" />
    <template v-else>
      <section id="catalog-page" class="detail-section fixed-sm-cls pt-0">
        <div class="container-fluid p-0">
          <h1 v-if="all_store_menu_items_being_loaded">
            {{ _T('LOADING') }}....
          </h1>
          <div class="row m-0" v-else>
            <div class="col p-0">
              <menu-list :key="renderkey"></menu-list>
            </div>
            <!-- <div class="col-xl-3 col-lg-4 p-0">
              <cart></cart>
            </div> -->
          </div>
        </div>
      </section>
      <mobile-cart-bar></mobile-cart-bar>
      <whats-app v-if="showWhatsapp" :whatsapplink="showWhatsapp"></whats-app>
      <category-menu-button v-if="showMobileMenu"></category-menu-button>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import MenuList from '../Blocks/MenuList'
// import ItemDetail from '../Blocks/Cart/Items/ItemDetail'
import MobileCartBar from '../Blocks/Cart/MobileCartBar'
import CategoryMenuButton from '../Blocks/Menu/CategoryMenuButton'
import WhatsApp from '../Blocks/Menu/WhatsApp'
import Loader from '@/components/Elements/Loader'
import Delivery from '@/mixins/Delivery'

export default {
  name: 'Catalog',
  mixins: [Delivery],
  data() {
    return {
      renderkey: 0,
    }
  },
  components: {
    MenuList,
    MobileCartBar,
    CategoryMenuButton,
    Loader,
    WhatsApp,
  },
  computed: {
    ...mapGetters([
      '_T',
      'all_store_menu_items_being_loaded',
      'currentBrand',
      'currentStore',
      'delivery_available',
      '_T_DB',
      'selectedDa',
    ]),
    ...mapState({
      openPopup: state => state.brand_store.openModifier,
    }),
    showMobileMenu() {
      return (
        this.$store.getters.currentBrand &&
        this.$store.getters.currentBrand.show_flot_menulist
      )
    },
    showWhatsapp() {
      return (
        this.$store.getters.currentBrand &&
        this.$store.getters.currentBrand.whatsapp_link
      )
    },
  },
  watch: {
    selectedDa() {
      this.renderkey += 1
    },
  },
  props: { modifiers: Array, item: Object, isModalVisible: Boolean },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$bvModal.hide('open-search')
      vm.$store.commit('SET_SEARCH_TERM', '')
    })
  },
  beforeRouteLeave(to, from, next) {
    if (to.name != '404') next()
    else next({ name: 'home' })
  },
}
</script>
<style lang="scss" scoped>
.delivery-alert {
  position: fixed;
  top: 66px;
  z-index: 9999999;
  padding: 14px;
  font-size: 19px;
  text-align: center;
  width: 100%;
}
</style>
